<template>
  <nav class="navbar columns is-mobile">
    <div
      class="navbar__left column is-half-mobile is-half-tablet is-one-quarter-desktop"
    >
      <img
        src="../assets/images/navbar-logo.png"
        alt="Logo ContaFácil"
        class="is-hidden-touch"
      />
      <img
        src="../assets/images/navbar-logo-mobile.png"
        alt="Logo ContaFácil"
        class="is-hidden-desktop"
      />
    </div>
    <div class="navbar__right column is-hidden-touch">
      <ul class="navbar__links">
        <li
          class="navbar__link"
          :class="{ 'navbar__link--active': $route.name == 'Home' }"
        >
          <a @click="$router.push({ name: 'Home' })">Inicio</a>
        </li>
        <li
          class="navbar__link"
          :class="{ 'navbar__link--active': $route.meta.isHowItWorks }"
          @mouseover="innerMenu = true"
          @mouseleave="innerMenu = false"
        >
          <a>Cómo funciona</a>
          <div class="navbar__link-innermenu-wrap" v-show="innerMenu">
            <div class="triangle-wrapper">
              <div class="triangle-with-shadow"></div>
            </div>
            <div class="navbar__link-innermenu columns">
              <div class="innermenu  column is-half column is-half">
                <img
                  src="../assets/images/icons/icon-ventas.png"
                  alt
                  class="logo"
                /><a
                  :class="{ 'inner-active': $route.name == 'sales' }"
                  @click.stop="toView('sales')"
                  @touchend="toView('sales')"
                  >Ventas</a
                >
              </div>
              <!-- <div class="innermenu  column is-half">
                <img
                  src="../assets/images/icons/icon-cotizaciones.png"
                  alt
                  class="logo"
                /><a
                  :class="{ 'inner-active': $route.name == 'marketrates' }"
                  @click.stop="toView('marketrates')"
                  @touchend="toView('marketrates')"
                  >Cotizaciones</a
                >
              </div>
              <div class="innermenu  column is-half">
                <img
                  src="../assets/images/icons/icon-guiasremision.png"
                  alt
                  class="logo"
                /><a
                  :class="{ 'inner-active': $route.name == 'referralguide' }"
                  @click.stop="toView('referralguide')"
                  @touchend="toView('referralguide')"
                  >Guías de Remisión</a
                >
              </div> -->
              <div class="innermenu  column is-half">
                <img
                  src="../assets/images/icons/icon-clientesproveedores.png"
                  alt
                  class="logo"
                /><a
                  :class="{ 'inner-active': $route.name == 'client-provider' }"
                  @click.stop="toView('client-provider')"
                  @touchend="toView('client-provider')"
                  >Clientes y proveedores</a
                >
              </div>
              <div class="innermenu  column is-half">
                <img
                  src="../assets/images/icons/icon-gastoscompras.png"
                  alt
                  class="logo"
                /><a
                  :class="{
                    'inner-active': $route.name == 'expenses-purchases'
                  }"
                  @click.stop="toView('expenses-purchases')"
                  @touchend="toView('expenses-purchases')"
                  >Gastos y compras</a
                >
              </div>
              <div class="innermenu  column is-half">
                <img
                  src="../assets/images/icons/icon-inventario.png"
                  alt
                  class="logo"
                /><a
                  :class="{ 'inner-active': $route.name == 'inventory' }"
                  @click.stop="toView('inventory')"
                  @touchend="toView('inventory')"
                  >Inventario</a
                >
              </div>
              <div class="innermenu  column is-half">
                <img
                  src="../assets/images/icons/icon-reportes.png"
                  alt
                  class="logo"
                /><a
                  :class="{ 'inner-active': $route.name == 'reports' }"
                  @click.stop="toView('reports')"
                  @touchend="toView('reports')"
                  >Reportes</a
                >
              </div>
            </div>
          </div>
        </li>
        <li
          class="navbar__link"
          :class="{ 'navbar__link--active': $route.name == 'plans' }"
        >
          <a @click.stop="$router.push({ name: 'plans' })">Planes</a>
        </li>
        <!-- <li
          class="navbar__link"
          :class="{ 'navbar__link--active': $route.meta.isBlog }"
          v-if="false"
        >
          <a @click.stop="$router.push({ name: 'blog' })">Blog</a>
        </li> -->
        <li
          class="navbar__link"
          :class="{ 'navbar__link--active': $route.name == 'contact' }"
        >
          <a @click.stop="$router.push({ name: 'contact' })">Contacto</a>
        </li>
        <li
          class="navbar__link"
          :class="{ 'navbar__link--active': $route.meta.isSupport }"
          v-if="false"
        >
          <a @click.stop="$router.push({ name: 'support' })">Soporte</a>
        </li>
        <li class="navbar__link">
          <a
            href="https://consultas.contafacil.pe/"
            target="_blank"
            rel="noopenner noreferer"
            >Consulta CPE</a
          >
        </li>
        <li class="navbar__link">
          <a
            class="test"
            rel="noopenner noreferer"
            href="https://app.contafacil.pe/#!/registro"
            @click="emitGlobalTriggerGtag('prueba_gratis')"
            >Prueba Gratis</a
          >
        </li>
        <li class="navbar__link">
          <a
            class="login"
            rel="noopenner noreferer"
            href="https://app.contafacil.pe/#/login"
            @click="emitGlobalTriggerGtag('pre_ingreso')"
            >Ingresar</a
          >
        </li>
      </ul>
    </div>
    <div
      class="navbar__menu column is-one-quarter is-offset-one-quarter is-mobile is-hidden-desktop"
    >
      <Menu @click="isMenuActive = !isMenuActive"></Menu>
      <side-bar v-if="isMenuActive" @close-menu="isMenuActive = false" />
    </div>
  </nav>
</template>

<script>
import Menu from "vue-material-design-icons/Menu.vue";
import SideBar from "../components/SideBar";
import { EventBus } from "@/event-bus";
export default {
  name: "NavBar",
  components: {
    Menu,
    SideBar
  },
  data() {
    return {
      innerMenu: false,
      isMenuActive: false
    };
  },
  methods: {
    emitGlobalTriggerGtag(type) {
      EventBus.$emit("triggerGtag", type);
    },
    toView(path) {
      this.$router.push({ name: path });
      this.innermenu = false;
    }
  }
};
</script>

<style lang="scss">
@import "../assets/styles/general.scss";
.navbar {
  position: fixed;
  height: 75px;
  left: 0px;
  right: 0px;
  background-color: #ffffff;
  z-index: 10;
  margin: 0px !important;
  flex-direction: row;
  -webkit-box-shadow: 0px 1px 5px 0px rgba(#909090, 0.75);
  -moz-box-shadow: 0px 1px 5px 0px rgba(#909090, 0.75);
  box-shadow: 0px 1px 5px 0px rgba(#909090, 0.75);
  @include laptop() {
    height: 120px;
  }
  @include desktop-large() {
    height: 120px;
  }
  &__menu {
    display: flex;
    flex-flow: column;
    justify-content: center;
    align-items: center;
    position: relative;
    span {
      font-size: 24px;
      cursor: pointer;
    }
    @include tablet-landscape() {
      // display: none !important;
    }
  }
  &__left {
    display: flex !important;
    justify-content: center;
    align-items: center;
    img {
      height: 75%;
      width: auto;
      object-fit: contain;
    }
    @include laptop() {
      flex: 0 0 25% !important;
      max-width: 25% !important;
      // img {
      //   height: 53px;
      //   width: 98px;
      // }
    }
  }
  &__right {
    // display: none !important;
    @include tablet-landscape() {
      display: flex;
      justify-content: center;
      align-items: center;
      padding-right: 1rem;
    }
    @include laptop() {
      flex: 0 0 75% !important;
      max-width: 75% !important;
      justify-content: flex-end;
    }
  }
  &__links {
    list-style: none;
    margin-bottom: 0px !important;
    display: flex;
    flex-flow: row nowrap;
    justify-content: flex-start;
    align-items: center;
  }
  &__link {
    display: inline;
    margin: 0 16px;
    position: relative;
    a {
      color: #414141;
      font-weight: bold;
      font-size: 16px;
      cursor: pointer;
      @include tablet() {
        font-size: 14px;
      }
      @media (min-width: 1024px) {
        font-size: 12px;
      }
      @media (min-width: 1200px) {
        font-size: 16px;
      }
      @include desktop-large() {
        font-size: 1.2rem;
        letter-spacing: 0.05em;
      }
    }
    &--active {
      a {
        color: $primary;
        font-weight: bold;
      }
    }
    &-innermenu-wrap {
      // position: relative;
      position: absolute;
      top: -10px;
      background-color: transparent;
      .triangle-wrapper {
        // position: absolute;
        // top: -48px;
        // left: 67px;
        .triangle-with-shadow {
          width: 50px;
          height: 50px;
          margin-left: 0;
          position: relative;
          overflow: hidden;
          box-shadow: 0 0px 10px -17px rgba(0, 0, 0, 0.5);
        }
        .triangle-with-shadow:after {
          content: "";
          position: absolute;
          width: 25px;
          height: 25px;
          background: #ffffff;
          transform: rotate(45deg);
          top: 37px;
          left: 16px;
          box-shadow: -1px -1px 2px -2px rgba(0, 0, 0, 0.5);
        }
      }
      @include desktop-large() {
        top: 15px;
        .triangle-wrapper {
          .triangle-with-shadow {
            width: 50px;
            height: 50px;
            margin-left: 0;
            position: relative;
            overflow: hidden;
            box-shadow: 0 0px 10px -17px rgba(0, 0, 0, 0.5);
          }
          .triangle-with-shadow:after {
            content: "";
            position: absolute;
            width: 25px;
            height: 25px;
            background: #ffffff;
            transform: rotate(45deg);
            top: 30px;
            left: 0px;
            box-shadow: -1px -1px 2px -2px rgba(0, 0, 0, 0.5);
          }
        }
      }
    }
    &-innermenu {
      display: flex;
      flex-flow: row wrap;
      justify-content: flex-start;
      align-items: flex-start;
      background-color: #ffffff;
      border-radius: 10px;
      width: 380px;
      padding: 1rem;
      box-shadow: 0px 3px 5px 0px rgba(205, 205, 205, 1);
      .innermenu {
        margin: 1rem 0rem;
        padding: 0px;
        display: flex;
        flex-flow: row nowrap;
        justify-content: flex-start;
        align-items: center;
        // width: 155px;
        img {
          // width: 24px;
          max-height: 20px;
          margin-right: 8px;
        }
        a {
          color: #000000;
          font-size: 0.8rem;
        }
        .inner-active {
          color: $primary;
        }
        @include desktop-large() {
          a {
            font-size: 1rem;
          }
        }
      }
      @include desktop-large() {
        width: 500px;
      }
    }
    .test {
      background-color: $primary;
      border: 3px solid $primary;
      color: #ffffff;
      padding: 8px 16px;
      border-radius: 15px;
      &:hover {
        background-color: #ffffff;
        color: $primary;
      }
    }
    .login {
      border: 3px solid $primary;
      background-color: #ffffff;
      color: $primary;
      padding: 8px 16px;
      border-radius: 15px;
      &:hover {
        color: #ffffff;
        background-color: $primary;
      }
    }
  }
}
a:hover {
  color: $primary;
}
</style>
